export default __webpack_public_path__ + "static/media/shelves.a26de849.png";